module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "mdl-card mdl-shadow--2dp",
    attrs: {
      "name": "client_form",
      "hook": "formHook",
      "id": "client-form"
    }
  }, [_c('span', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom:insert_into_header",
      arg: "insert_into_header"
    }]
  }, [_c('div', {
    staticClass: "select-client"
  }, [_c('v-client-list')], 1)]), _c('div', {
    staticClass: "mdl-card__supporting__text"
  }, [_c('div', {
    staticClass: "mdl-tabs mdl-js-tabs mdl-js-ripple-effect"
  }, [_c('div', {
    staticClass: "mdl-tabs__tab-bar"
  }, [_c('a', {
    ref: "first_tab",
    staticClass: "mdl-tabs__tab is-active",
    attrs: {
      "href": "#general"
    }
  }, [_vm._v("Allmänt")]), _c('a', {
    staticClass: "mdl-tabs__tab",
    attrs: {
      "href": "#properties"
    }
  }, [_vm._v("Uppgifter")])]), _c('div', {
    staticClass: "mdl-tabs__panel is-active",
    attrs: {
      "id": "general"
    }
  }, [_c('div', {
    staticClass: "gridform"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('fieldset', [_c('legend', [_vm._v("Allmänt")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('v-textfield', {
    attrs: {
      "id": "client_id",
      "name": "KlientID",
      "label": "Klientkod",
      "is-invalid": _vm.id_is_invalid,
      "error-msg": "Klientkoden är upptagen"
    },
    model: {
      value: (_vm.client.id),
      callback: function($$v) {
        _vm.$set(_vm.client, "id", $$v)
      },
      expression: "client.id"
    }
  })], 1), _c('div', {
    staticClass: "cell"
  }, [_c('v-textfield', {
    attrs: {
      "id": "client_year",
      "label": "Födelseår",
      "is-invalid": _vm.year_is_invalid,
      "error-msg": 'Året skall vara en siffra mellan ' + _vm.min_year + ' och ' + _vm.max_year
    },
    on: {
      "input": _vm.checkYear
    },
    model: {
      value: (_vm.client.year),
      callback: function($$v) {
        _vm.$set(_vm.client, "year", $$v)
      },
      expression: "client.year"
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('fieldset', [_c('legend', [_vm._v("Kön")]), _c('v-radiobutton-group', {
    attrs: {
      "id": "gender",
      "labels": ['Kvinna', 'Man', 'Annat'],
      "values": ['woman', 'man', 'hen'],
      "name": "gender"
    },
    model: {
      value: (_vm.client.gender),
      callback: function($$v) {
        _vm.$set(_vm.client, "gender", $$v)
      },
      expression: "client.gender"
    }
  })], 1)])])])]), _c('div', {
    staticClass: "cell"
  }, [_c('fieldset', [_c('legend', [_vm._v("Status")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('v-datefield', {
    attrs: {
      "id": "client_start",
      "label": "Aktiv",
      "validate": "date_format:YYYY-MM-DD"
    },
    model: {
      value: (_vm.client.start),
      callback: function($$v) {
        _vm.$set(_vm.client, "start", $$v)
      },
      expression: "client.start"
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('v-datefield', {
    attrs: {
      "id": "client_end",
      "label": "Avslutad",
      "validate": "date_format:YYYY-MM-DD"
    },
    model: {
      value: (_vm.client.end),
      callback: function($$v) {
        _vm.$set(_vm.client, "end", $$v)
      },
      expression: "client.end"
    }
  })], 1)])])])])])]), _c('div', {
    staticClass: "mdl-tabs__panel",
    attrs: {
      "id": "properties"
    }
  }, [_c('div', {
    staticClass: "gridform"
  }, _vm._l((_vm.groups.getEmbeds('client_property_groups')), function(group) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('fieldset', [_c('legend', [_vm._v(_vm._s(group.name))]), _vm._l((group.getEmbeds('client_property_definitions')), function(cprop) {
      return _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "cell",
        attrs: {
          "id": 'cell_' + cprop.name
        }
      }, [(cprop.type == 'STRING') ? _c('v-textfield', {
        attrs: {
          "id": 'cprop_' + cprop.name,
          "label": cprop.label
        },
        model: {
          value: (_vm.props[cprop.uid]),
          callback: function($$v) {
            _vm.$set(_vm.props, cprop.uid, $$v)
          },
          expression: "props[cprop.uid]"
        }
      }) : _vm._e(), (cprop.type == 'BOOLEAN') ? _c('v-checkbox', {
        attrs: {
          "id": 'cprop_' + cprop.name,
          "label": cprop.label,
          "value": _vm.getPropertyValue(cprop.uid)
        },
        on: {
          "change": function($event) {
            _vm.setPropertyValue(cprop.uid, arguments[0])
          }
        }
      }) : _vm._e(), (cprop.type == 'ARRAY') ? _c('v-multi_checkbox', {
        attrs: {
          "options": cprop.getEmbeds('client_property_option'),
          "label": cprop.label,
          "value": _vm.getPropertyValue(cprop.uid)
        },
        on: {
          "change": function($event) {
            _vm.setPropertyValue(cprop.uid, arguments[0])
          }
        }
      }) : _vm._e()], 1), (cprop.description) ? _c('span', {
        staticClass: "mdl-tooltip",
        attrs: {
          "data-mdl-for": 'cprop_' + cprop.name
        }
      }, [_vm._v(_vm._s(cprop.description))]) : _vm._e()])
    })], 2)])])
  }))])]), _c('footer', {
    attrs: {
      "id": "footer-color-text--grey-600"
    }
  }, [_c('div', {
    staticClass: "button-group-fab"
  }, [_c('v-fab-button', {
    attrs: {
      "id": "new_button",
      "icon": "add"
    },
    on: {
      "clicked": function($event) {
        _vm.newClient()
      }
    }
  }), _c('v-fab-button', {
    attrs: {
      "id": "save_button",
      "icon": "save"
    },
    on: {
      "clicked": function($event) {
        _vm.saveClient(_vm.client)
      }
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b2ac8f8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ClientForm.vue
// module id = 527
// module chunks = 1